import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { App } from "./App";
import { AuthProvider } from "./auth/AuthProvider";
import { LocaleProvider } from "./i18n/LocaleProvider";
import { ThemeProvider } from "./theme/ThemeProvider";
import { applyScheme, applyTheme, cachedScheme, cachedTheme } from "./theme/themes";
import { queryClient } from "./api/queryClient";
import "./index.css";

// Paint in this tab's last theme and scheme before React renders anything, so
// a reload does not flash the default while /me is on its way.
const cached = cachedTheme();
if (cached) applyTheme(cached);
const cachedSch = cachedScheme();
if (cachedSch) applyScheme(cachedSch);

const container = document.getElementById("root");
if (!container) {
  throw new Error("#root is missing from index.html");
}

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        {/*
          Inside AuthProvider because it reads /me to learn the language, and
          outside App because the sign-in screen needs a language too.
        */}
        <LocaleProvider>
          <ThemeProvider>
            <App />
          </ThemeProvider>
        </LocaleProvider>
      </AuthProvider>
    </QueryClientProvider>
  </StrictMode>,
);
